export function clamp(v, a, b) {
  return Math.max(a, Math.min(b, v))
}

export function cap(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''
}

export function today() {
  return new Date().toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function fmtBudget(n, currency, currSym) {
  if (!n || isNaN(n)) return `${currSym}0`
  const isINR =
    currency === 'INR' ||
    currSym === '₹' ||
    /INR|RUPEE/i.test(currency || '')
  if (isINR) {
    if (n >= 10000000)
      return `${currSym}${(n / 10000000).toFixed(2).replace(/\.?0+$/, '')} Cr`
    if (n >= 100000)
      return `${currSym}${(n / 100000).toFixed(1).replace(/\.0$/, '')} L`
    if (n >= 1000)
      return `${currSym}${(n / 1000).toFixed(1).replace(/\.0$/, '')} K`
    return `${currSym}${Math.round(n).toLocaleString()}`
  }
  if (n >= 1000000)
    return `${currSym}${(n / 1000000).toFixed(2).replace(/\.?0+$/, '')} M`
  if (n >= 1000)
    return `${currSym}${(n / 1000).toFixed(1).replace(/\.0$/, '')} K`
  return `${currSym}${Math.round(n).toLocaleString()}`
}
